export const columns = [
  {
    title: '序号',
    customRender: (text, record, index) => index + 1,
  },
  {
    title: '问题详情',
    dataIndex: 'question',
  },
  {
    title: '问题类型',
    dataIndex: 'type',
    customRender: (text, record, index)=>{
      if(record.type===0){
        return '问答题';
      }else if(record.type===1){
        return '单选题';
      }else{
        return '多选题';
      }
    },
  },
  {
    title: '状态',
    dataIndex: 'status',
    customRender: (text, record, index)=>{
      return record.status===0?'禁用':'启用';
    },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];
